/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ExternalProfessional/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import Separator from './Separator/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function ExternalProfessional({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/ExternalProfessionals/Content/ExternalProfessional"
  
}) {
let externalProfessionalOtherPersonValueData = fromData.useDataFormat({ viewPath,
context: 'external_professional',
path: 'other.person',
format: fromFormat.personName,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="external_professional.other.person"
 format="/Data/format.js personName"
 text={externalProfessionalOtherPersonValueData}
/>
<Separator
  viewPath={`${viewPath}/Separator`}
/>
{children}
</React.Fragment>)
}